import KeyBenefits from './KeyBenefits';
import CTAButtons from './CTAButtons';

const MockInterviewHero = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="relative text-white overflow-hidden">
      <div className="relative container mx-auto max-w-6xl px-4 py-16">
        <div className="text-center max-w-4xl mx-auto">

          {/* Main headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Ace Your Tech Interview
            <span className="block mt-2 bg-gradient-to-r  from-orange-300 via-orange-400 to-amber-400 bg-clip-text text-transparent">
              Expert-Led Mock Interviews
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl md:text-2xl mb-8 text-green-100 leading-relaxed max-w-3xl mx-auto">
            Practice with experienced engineers, get detailed feedback, and build the confidence you need to land your dream job
          </p>

          {/* Key benefits - 3 columns */}
          <KeyBenefits className="mb-10 max-w-3xl mx-auto text-left" />

          {/* CTA Buttons */}
          <CTAButtons
            primaryText="Check Mock Interview Packages"
            primaryOnClick={scrollToPricing}
            secondaryText="Learn More"
            secondaryOnClick={() => {
              const benefitsSection = document.getElementById('benefits-section');
              if (benefitsSection) {
                benefitsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default MockInterviewHero;
